import * as colors from '../assets/colors/colors.css';
export const COLORS = {
  LightTextPrimary: colors['--light-text-primary'],
  LightControlPrimary: colors['--light-control-primary-basic'],
};

export const SIMPLIFY_COLORS = {
  primary: COLORS.LightTextPrimary,
  controlPrimary: COLORS.LightControlPrimary,
  currentColor: 'currentColor',
};
